var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Regular / pencil-write"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pencil-write"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55536 6.02773L4.47266 6.18261L4.62724 5.09961L7.41159 2.31527C7.66788 2.05897 8.08341 2.05897 8.33971 2.31527C8.596 2.57156 8.596 2.98709 8.33971 3.24338L5.55536 6.02773Z",
    stroke: "gray",
    strokeWidth: 0.655863
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M7.10547 2.62305L8.03358 3.55116",
    stroke: "gray",
    strokeWidth: 0.655863
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    d: "M7.22284 6.06064V8.24821C7.22284 8.48985 7.02696 8.68573 6.78532 8.68573H2.41017C2.16854 8.68573 1.97266 8.48985 1.97266 8.24821V3.87306C1.97266 3.63143 2.16854 3.43555 2.41017 3.43555H4.59775",
    stroke: "gray",
    strokeWidth: 0.655863
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.8a0af59f19db3c6645142e8c4da4a9ec.svg";
export { ForwardRef as ReactComponent };